import React, { useState } from 'react';
import { colors, spacing, typography, borders, shadows, transitions } from '../../../../tokens';
import { Card } from '../../../../atoms';

interface StreamOption {
  id: string;
  name: string;
  basePercentage: number;
  growthMultiplier: number;
  isActive: boolean;
}

const streamOptions: StreamOption[] = [
  { id: 'inference', name: 'Far Inference', basePercentage: 8, growthMultiplier: 1.05, isActive: false },
  { id: 'gpu', name: 'Far GPU De-Pin', basePercentage: 6, growthMultiplier: 1.15, isActive: false },
  { id: 'game', name: 'Farcana Game', basePercentage: 4, growthMultiplier: 1.03, isActive: false },
  { id: 'desci', name: 'Far DeSci', basePercentage: 2, growthMultiplier: 1.02, isActive: false },
  { id: 'gamed', name: 'Far GameD', basePercentage: 3, growthMultiplier: 1.04, isActive: false },
  { id: 'twinai', name: 'FarTwin AI', basePercentage: 5, growthMultiplier: 1.08, isActive: false },
];

export const StreamSelection: React.FC = () => {
  const [selectedStream, setSelectedStream] = useState<string | null>(null);
  const [hoveredStream, setHoveredStream] = useState<string | null>(null);

  return (
    <div>
      <h2 style={{
        fontSize: typography.fontSize['2xl'],
        fontWeight: typography.fontWeight.extrabold,
        fontFamily: typography.fontFamily.heading,
        color: colors.text.primary.default,
        margin: `0 0 ${spacing.lg} 0`,
        textTransform: 'uppercase' as const,
        letterSpacing: typography.letterSpacing.wide,
      }}>
        Stream Selection
      </h2>
      <Card padding="2xl">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: spacing.lg,
        }}>
          {streamOptions.map((stream) => {
            const isSelected = selectedStream === stream.id;
            const isHovered = hoveredStream === stream.id;
            const canSelect = stream.isActive;

            return (
              <button
                key={stream.id}
                onClick={() => canSelect && setSelectedStream(stream.id)}
                onMouseEnter={() => setHoveredStream(stream.id)}
                onMouseLeave={() => setHoveredStream(null)}
                disabled={!canSelect}
                style={{
                  padding: spacing.lg,
                  backgroundColor: colors.background.secondary.default,
                  border: `2px solid ${isSelected ? colors.brand.purple.base : colors.border.default.default}`,
                  borderRadius: borders.component.default.radius,
                  cursor: canSelect ? 'pointer' : 'not-allowed',
                  textAlign: 'left',
                  transition: transitions.button,
                  boxShadow: isSelected
                    ? shadows.glow.purple.md
                    : 'none',
                  transform: (canSelect && isHovered)
                    ? 'translateY(-2px)'
                    : 'translateY(0)',
                  opacity: canSelect ? 1 : 0.5,
                }}
              >
                <div style={{
                  fontSize: typography.fontSize.lg,
                  fontWeight: typography.fontWeight.semibold,
                  color: isSelected ? colors.brand.purple.light : colors.text.primary.default,
                  marginBottom: spacing.xs,
                }}>
                  {stream.name}
                </div>
                <div style={{
                  fontSize: typography.fontSize.sm,
                  color: colors.text.muted.default,
                  marginBottom: spacing.xs,
                }}>
                  Base {stream.basePercentage}% • Growth x{stream.growthMultiplier.toFixed(2)}
                </div>
                <div style={{
                  fontSize: typography.fontSize.xs,
                  color: colors.text.muted.default,
                  fontStyle: 'italic',
                }}>
                  Coming soon...
                </div>
              </button>
            );
          })}
        </div>
      </Card>
    </div>
  );
};
